import { Injectable } from "@angular/core"
import { HttpClient } from "@angular/common/http"

import { environment } from "../../environments/environment"
import { WpTokenService } from "../core/auth/wp-token.service"
import { decryptData } from "../core/utilities"

@Injectable()
export class UpdateCustomerPaymentQRSercice {
  constructor(
    public httpClient: HttpClient,
    public wpTokenService: WpTokenService
  ) {}

  private VERIFY_TOKEN_EXPIRE = false

  httpClientOptions() {
    // TODO: Stuff
    const httpClientOptions = {
      headers: {
        "Content-Type": "application/json",
      },
      observe: "response" as "body",
    }
    if (this.VERIFY_TOKEN_EXPIRE) {
      let token = this.wpTokenService.getToken()
      httpClientOptions.headers["Authorization"] = token
    }
    return httpClientOptions
  }

  input(param: any) {
    return param
  }

  output(result: any) {
    return result
  }

  connector(param: any, ref: any = "") {
    const url = `${environment.endpointBackend}/api/query/updateCustomerPaymentQR`
    const body = this.input(param)
    return this.httpClient.post(url, body, this.httpClientOptions())
  }

  // Core Function ! No modify
  exec(param: any, ref: any = "") {
    const self = this
    return new Promise(function (resolve, reject) {
      if (!self.VERIFY_TOKEN_EXPIRE || !self.wpTokenService.isTokenExpired()) {
        self.connector(param, ref).subscribe(
          (res) => {
            self.wpTokenService.storeToken(res["headers"].get("Authorization"))
            resolve(self.output(res["body"]))
          },
          (err) => {
            reject(err)
          }
        )
      } else {
        reject({
          name: "WP_TOKEN_EXCEPTION",
          httpStatus: 401,
          message: "token is expired",
        })
      }
    })
  }
}
